export default "__VITE_ASSET__dXfkqLml__"